import { UsageExplorerViewToken } from "../../types/analytics/UsageExplorerViewToken";
import {
  UsageFocusPriority,
  UsageFocusRecommendationDto,
  UsageFocusViewTokenDto,
} from "../../types/analytics/UsageFocusDto";

const PRIORITY_ORDER: Record<UsageFocusPriority, number> = {
  HIGH: 0,
  MEDIUM: 1,
  LOW: 2,
};

/**
 * Converts a server view token into the explorer's own token shape. The API uses
 * nulls for "not set" whereas the explorer treats those keys as absent, and a
 * manager focus is only meaningful on the manager lens.
 */
export function toExplorerViewToken(
  token: UsageFocusViewTokenDto,
): UsageExplorerViewToken {
  return {
    lens: token.lens,
    attentionCardId: token.attentionCardId ?? undefined,
    locationBreadcrumbIds:
      token.lens === "BY_LOCATION" ? (token.locationBreadcrumbIds ?? []) : [],
    managerId:
      token.lens === "BY_MANAGER" ? (token.managerId ?? undefined) : undefined,
    searchText: token.searchText ?? "",
    showDistribution: token.showDistribution === true,
  };
}

export function sortFocusRecommendations(
  recommendations: UsageFocusRecommendationDto[],
): UsageFocusRecommendationDto[] {
  return [...recommendations].sort(
    (a, b) => PRIORITY_ORDER[a.priority] - PRIORITY_ORDER[b.priority],
  );
}

export function areExplorerViewTokensEqual(
  a: UsageExplorerViewToken | null | undefined,
  b: UsageExplorerViewToken | null | undefined,
): boolean {
  if (!a || !b) {
    return false;
  }

  return (
    a.lens === b.lens &&
    a.attentionCardId === b.attentionCardId &&
    a.managerId === b.managerId &&
    a.showDistribution === b.showDistribution &&
    a.searchText === b.searchText &&
    a.locationBreadcrumbIds.length === b.locationBreadcrumbIds.length &&
    a.locationBreadcrumbIds.every(
      (id, index) => id === b.locationBreadcrumbIds[index],
    )
  );
}

/** Matches the explorer table chip Clear behaviour. */
export function clearExplorerViewTokenFilter(
  token: UsageExplorerViewToken | null,
): UsageExplorerViewToken {
  const base = token ?? createDefaultExplorerViewToken();
  return {
    ...base,
    attentionCardId: undefined,
    managerId: undefined,
  };
}

export function createDefaultExplorerViewToken(): UsageExplorerViewToken {
  return {
    lens: "BY_MANAGER",
    locationBreadcrumbIds: [],
    searchText: "",
    showDistribution: false,
  };
}
